<template>
  <mu-card>
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <mu-icon :size="16" class="card-left-icon" value="file_download"></mu-icon>
        <mu-flexbox-item class="left16">{{ $t('message.exportTextData') }}</mu-flexbox-item>
        <mu-flexbox-item
          align="right"
        >
          <mu-icon-button
            class="card-bar-icon"
            :icon="isOpen ? 'remove_circle_outline' : 'add_circle'"
            @click.native="toggleOpen"
          />
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <transition :css="false" @enter="onToggleEnter" @leave="onToggleLeave">
      <mu-card-text v-if="isOpen" style="overflow: hidden">
        <mu-row gutter>
          <mu-col width="100" desktop="50" tablet="50">
            <mu-date-picker
              :label="$t('message.labelFromDate')"
              v-model="fromDate"
              :dateTimeFormat="dateFormat"
              :okLabel="$t('message.okText')"
              :cancelLabel="$t('message.cancelText')"
              format="DD-MM-YYYY"
              fullWidth
            >
            </mu-date-picker>
          </mu-col>
          <mu-col width="100" desktop="50" tablet="50">
            <mu-date-picker
              :label="$t('message.labelToDate')"
              v-model="toDate"
              :dateTimeFormat="dateFormat"
              :okLabel="$t('message.okText')"
              :cancelLabel="$t('message.cancelText')"
              format="DD-MM-YYYY"
              fullWidth
            >
            </mu-date-picker>
          </mu-col>
        </mu-row>
        <div v-if="isOpen" align="right">
          <mu-flat-button @click.native="toggleOpen" :label="$t('message.discardText')"></mu-flat-button>
          <mu-flat-button :label="isExporting ? $t('message.exportingText') : $t('message.exportText')" :disabled="isExporting"
                          @click.native="exportData"></mu-flat-button>
        </div>
      </mu-card-text>
    </transition>


  </mu-card>
</template>
<script>

  import axios from 'axios';
  import config from "../../../config"

  import dateFormat from "../../../helpers/DatePickerManager"
  
  import download from 'downloadjs'
  import CardAnimationMixin from '../../../mixins/CardAnimationMixin'

  export default {
    mixins: [CardAnimationMixin],
    name: 'tracking-exporter',
    props: {
      type: {
        type: String,
        default: 'weight'
      }

    },
    data() {
      return {
        isExporting: false,
        isOpen: false,
        dateFormat: dateFormat,
        fromDate: moment().subtract(1, 'month').format('DD-MM-YYYY'),
        toDate: moment().format('DD-MM-YYYY')
      }
    },
    methods: {
      exportData() {
        let self = this;
        const fileName = self.type + `_${self.fromDate}_${self.toDate}.xlsx`;
        const requestPath = `tracking/${self.type}/export?fromDate=${self.fromDate}&toDate=${self.toDate}`;
        const finalUrl = config.apiUrl + requestPath;
        const errorMessage = self.$t('message.errorExportEmpty');
        self.isExporting = true;
        axios.get(finalUrl, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/vnd.ms-excel'
          }
        })
          .then(function (response) {
            if (response.status === 200) {
              const timestamp = self.isExporting = false;
              self.$toastr.success(self.$t('message.justAMomentText'));
              download(response.data, fileName);
            }
            else if (response.status === 204) {
              self.$toastr.error(errorMessage);
              self.isExporting = false;
            }
            else {
              self.$toastr.error(errorMessage);
              self.isExporting = false;
            }
          })
          .catch(function () {
            self.$toastr.error(errorMessage);
            self.isExporting = false;
          })
      },
      toggleOpen() {
        let self = this;
        self.isOpen = !self.isOpen;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Exporter.vue?968d3eb0